import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

//const redirect_uri = 'http://localhost:8080';
const redirect_uri = 'https://nordic-ict-systems.phz.fi';
const apiUrlPrefix = 'https://d11gfjuwvk.execute-api.eu-central-1.amazonaws.com/v1/';

export const loginUrl = `https://nordic-ict-systems-admin.auth.eu-central-1.amazoncognito.com/oauth2/authorize?response_type=code&client_id=756o85i06a3o1tb5tf2gti2t6&redirect_uri=${redirect_uri}&state=new&identity_provider=COGNITO&scope=openid`;

const tokenUrl =
    'https://nordic-ict-systems-admin.auth.eu-central-1.amazoncognito.com/oauth2/token';

const logoutUrl = `https://nordic-ict-systems-admin.auth.eu-central-1.amazoncognito.com/logout?response_type=code&client_id=756o85i06a3o1tb5tf2gti2t6&redirect_uri=${redirect_uri}&state=new&identity_provider=COGNITO&scope=openid`;

const api = axios.create({
    baseURL: apiUrlPrefix,
    timeout: 30000,
});

function getRefreshParams() {
    const refresh_params = new URLSearchParams();
    refresh_params.append('grant_type', 'refresh_token');
    refresh_params.append('client_id', '756o85i06a3o1tb5tf2gti2t6');
    refresh_params.append('refresh_token', sessionStorage.getItem('refresh_token'));
    return refresh_params;
}

const refreshAuthLogic = (failedRequest) =>
    axios.post(tokenUrl, getRefreshParams()).then((tokenRefreshResponse) => {
        sessionStorage.setItem('access_token', tokenRefreshResponse.data.access_token);
        failedRequest.response.config.headers['Authorization'] =
            'Bearer ' + tokenRefreshResponse.data.access_token;
        return Promise.resolve();
    });

createAuthRefreshInterceptor(api, refreshAuthLogic);

export function navigateToLoginPage() {
    window.location.replace(loginUrl);
}

export function logout() {
    window.location.replace(logoutUrl);
}

export const sendTokenRequest = async (code) => {
    const params = new URLSearchParams();
    params.append('grant_type', 'authorization_code');
    params.append('code', code);
    params.append('redirect_uri', redirect_uri);
    params.append('client_id', '756o85i06a3o1tb5tf2gti2t6');

    try {
        const resp = await axios.post(tokenUrl, params);
        if (resp.data) {
            sessionStorage.setItem('access_token', resp.data.access_token);
        } else {
            console.log('error: couldn not get access_token');
        }

        if (resp.data) {
            sessionStorage.setItem('refresh_token', resp.data.refresh_token);
        } else {
            console.log('error: could not get refresh_token');
        }
        return resp.data.access_token;
    } catch (error) {
        if (error.response) {
            if (error.response.status === 400) {
                navigateToLoginPage();
            }
        }
    }
};

export const uploadFile = async (data) => {
    return await postRequest('admin-upload-file', data);
};

export const createFolder = async (data) => {
    return await postRequest('admin-create-folder', data);
};

export const createUser = async (data) => {
    return await postRequest('admin-create-user', data);
};

const postRequest = async (url, data) => {
    try {
        const resp = await api.post(url, data, {
            headers: { Authorization: `Bearer ${sessionStorage.getItem('access_token')}` },
        });
        return resp.data;
    } catch (error) {
        if (error.response) {
            if (error.response.status === 400) {
                navigateToLoginPage();
            }
        } else {
            throw error;
        }
    }
};

const axiosRequest = async (method, url, accept = '') => {
    let headers = accept
        ? { Authorization: `Bearer ${sessionStorage.getItem('access_token')}`, accept: accept }
        : { Authorization: `Bearer ${sessionStorage.getItem('access_token')}` };

    try {
        const resp = await api({
            method: method,
            url: url,
            headers: headers,
        });
        return resp.data;
    } catch (error) {
        if (error.response) {
            if (error.response.status === 400) {
                navigateToLoginPage();
            }
        } else {
            throw error;
        }
    }
};

const axiosDownloadRequest = async (method, url, accept = '') => {
    let headers = accept
        ? { Authorization: `Bearer ${sessionStorage.getItem('access_token')}`, accept: accept }
        : { Authorization: `Bearer ${sessionStorage.getItem('access_token')}` };

    try {
        const resp = await api({
            method: method,
            url: url,
            headers: headers,
            responseType: 'blob',
        });
        return resp.data;
    } catch (error) {
        if (error.response) {
            if (error.response.status === 400) {
                navigateToLoginPage();
            }
        } else {
            throw error;
        }
    }
};

export const deleteFile = async (fileWithPath) => {
    return await axiosRequest('delete', 'admin-delete-file/' + fileWithPath);
};

export const deleteFolder = async (folderWithPath) => {
    return await axiosRequest('delete', 'admin-delete-folder/' + folderWithPath);
};

export const deleteUser = async (username) => {
    return await axiosRequest('delete', 'admin-delete-user/' + username);
};

export const getFileList = async () => {
    return await axiosRequest('get', 'admin-list-files');
};

export const getUserList = async () => {
    return await axiosRequest('get', 'admin-list-users');
};

export const getAnalyticsFile = async () => {
    return await axiosDownloadRequest('get', 'admin-get-file?filename=analytics.csv', 'text/csv');
};

export const getFile = async (fileWithPath) => {
    return await axiosDownloadRequest(
        'get',
        'admin-get-file?filename=' + fileWithPath,
        'application/octet-stream'
    );
};

export const fileList = [
    { Key: 'QSFP/100Gb/Juniper/100G QSFP28 SR4 Juniper code.bin', Size: 256, Metadata: {} },
    { Key: 'QSFP/40Gb/Extreme/Extreme 40G SR4  MPO.bin', Size: 256, Metadata: {} },
    { Key: 'SFP/100Mb/Juniper/Juniper 100M BIDI 35.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/100Mb/Juniper/Juniper 100M BIDI 53.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Arista/SFP-10G-LR', Size: 128, Metadata: {} },
    { Key: 'SFP/10Gb/Arista/SFP-10G-SR', Size: 128, Metadata: {} },
    { Key: 'SFP/10Gb/Extreme/EXTREME 10G BIDI 27-33.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Extreme/EXTREME 10G CWDM.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Extreme/EXTREME 10G LR.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Juniper/Juniper 10G CWDM 1590.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Juniper/Juniper 10G CWDM 1610.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Juniper/Juniper 10G LR.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Juniper/Juniper 10G SR.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/1Gb/Arista/SFP-1G-LX', Size: 128, Metadata: {} },
    { Key: 'SFP/1Gb/Arista/SFP-1G-SX', Size: 128, Metadata: {} },
    { Key: 'SFP/1Gb/Juniper/Juniper 1G BIDI 49-31.bin', Size: 128, Metadata: {} },
    { Key: 'SFP/25Gb/Huawei/25G SFP28 SR Huawei.bin', Size: 384, Metadata: {} },
    { Key: 'XFP/10Gb/Extreme/Extreme 10G BIDI 2733.bin', Size: 256, Metadata: {} },
    { Key: 'XFP/10Gb/Extreme/Extreme 10G BIDI 3327.bin', Size: 256, Metadata: {} },
    { Key: 'XFP/10Gb/Extreme/Extreme 10G LR.bin', Size: 256, Metadata: {} },
    { Key: 'analytics.csv', Size: 12189, Metadata: { description: 'analytics data' } },
    { Key: 'test/foo/bar/', Size: 0, Metadata: {} },
    {
        Key: 'test/foo/bar/CIB180712077.bin',
        Size: 384,
        Metadata: { description: 'just testing', additional_info: 'no additional info available' },
    },
];
//export const fileList = '[{"Key":"SFP/100Mb/Juniper/Juniper 100M BIDI 35.bin","Size":384,"Metadata":{}},{"Key":"SFP/100Mb/Juniper/Juniper 100M BIDI 53.bin","Size":384,"Metadata":{}}]';
export const fileList_2 = [
    { Key: 'QSFP/', Size: 0, Metadata: {} },
    { Key: 'QSFP/100Gb/', Size: 0, Metadata: {} },
    { Key: 'QSFP/100Gb/Juniper/', Size: 0, Metadata: {} },
    { Key: 'QSFP/100Gb/Juniper/100G QSFP28 SR4 Juniper code.bin', Size: 256, Metadata: {} },
    { Key: 'QSFP/40Gb/', Size: 0, Metadata: {} },
    { Key: 'QSFP/40Gb/Extreme/', Size: 0, Metadata: {} },
    { Key: 'QSFP/40Gb/Extreme/Extreme 40G SR4  MPO.bin', Size: 256, Metadata: {} },
    { Key: 'SFP/', Size: 0, Metadata: {} },
    { Key: 'SFP/100Mb/', Size: 0, Metadata: {} },
    { Key: 'SFP/100Mb/Juniper/', Size: 0, Metadata: {} },
    { Key: 'SFP/100Mb/Juniper/Juniper 100M BIDI 35.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/100Mb/Juniper/Juniper 100M BIDI 53.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/', Size: 0, Metadata: {} },
    { Key: 'SFP/10Gb/Arista/', Size: 0, Metadata: {} },
    { Key: 'SFP/10Gb/Arista/SFP-10G-LR', Size: 128, Metadata: {} },
    { Key: 'SFP/10Gb/Arista/SFP-10G-SR', Size: 128, Metadata: {} },
    { Key: 'SFP/10Gb/Extreme/', Size: 0, Metadata: {} },
    { Key: 'SFP/10Gb/Extreme/EXTREME 10G BIDI 27-33.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Extreme/EXTREME 10G CWDM.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Extreme/EXTREME 10G LR.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Juniper/', Size: 0, Metadata: {} },
    { Key: 'SFP/10Gb/Juniper/Juniper 10G CWDM 1590.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Juniper/Juniper 10G CWDM 1610.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Juniper/Juniper 10G LR.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/10Gb/Juniper/Juniper 10G SR.bin', Size: 384, Metadata: {} },
    { Key: 'SFP/1Gb/', Size: 0, Metadata: {} },
    { Key: 'SFP/1Gb/Arista/', Size: 0, Metadata: {} },
    { Key: 'SFP/1Gb/Arista/SFP-1G-LX', Size: 128, Metadata: {} },
    { Key: 'SFP/1Gb/Arista/SFP-1G-SX', Size: 128, Metadata: {} },
    { Key: 'SFP/1Gb/Juniper/', Size: 0, Metadata: {} },
    { Key: 'SFP/1Gb/Juniper/Juniper 1G BIDI 49-31.bin', Size: 128, Metadata: {} },
    { Key: 'SFP/25Gb/', Size: 0, Metadata: {} },
    { Key: 'SFP/25Gb/Huawei/', Size: 0, Metadata: {} },
    { Key: 'SFP/25Gb/Huawei/25G SFP28 SR Huawei.bin', Size: 384, Metadata: {} },
    { Key: 'XFP/', Size: 0, Metadata: {} },
    { Key: 'XFP/10Gb/', Size: 0, Metadata: {} },
    { Key: 'XFP/10Gb/Extreme/', Size: 0, Metadata: {} },
    { Key: 'XFP/10Gb/Extreme/Extreme 10G BIDI 2733.bin', Size: 256, Metadata: {} },
    { Key: 'XFP/10Gb/Extreme/Extreme 10G BIDI 3327.bin', Size: 256, Metadata: {} },
    { Key: 'XFP/10Gb/Extreme/Extreme 10G LR.bin', Size: 256, Metadata: {} },
    { Key: 'analytics.csv', Size: 13469, Metadata: { description: 'analytics data' } },
    { Key: 'test/foo/bar/', Size: 0, Metadata: {} },
    {
        Key: 'test/foo/bar/testi.bin',
        Size: 384,
        Metadata: {
            description: '123456789 123456789 1234567890',
            additional_info: 'no additional info available lorem ipsum dolor sita amet',
        },
    },
    {
        Key: 'test/foo/bar/testi_2.bin',
        Size: 384,
        Metadata: { description: 'just testing', additional_info: 'no additional info available' },
    },
    {
        Key: 'test/foo/bar/testi_3.bin',
        Size: 384,
        Metadata: { description: 'just testing', additional_info: 'no additional info available' },
    },
    {
        Key: 'test/foo/bar/testi_4.bin',
        Size: 384,
        Metadata: { description: 'just testing', additional_info: 'no additional info available' },
    },
    {
        Key: 'test/foo/bar/testi_5.bin',
        Size: 384,
        Metadata: {
            description: 'diipa daapa jep jep',
            additional_info: 'no additional info available',
        },
    },
    {
        Key: 'test/foo/bar/testi_6.bin',
        Size: 384,
        Metadata: {
            description: 'qwerty uiopaå asdfgh',
            additional_info: 'no additional info available',
        },
    },
    {
        Key: 'test/foo/bar/testi_7.bin',
        Size: 384,
        Metadata: { description: 'just testing', additional_info: 'no additional info available' },
    },
    {
        Key: 'test/foo/bar/testi_8.bin',
        Size: 384,
        Metadata: { description: 'just testing', additional_info: 'no additional info available' },
    },
    {
        Key: 'test/foo/bar/testi_9.bin',
        Size: 384,
        Metadata: {
            description: 'kettu juoksi yli järven',
            additional_info: 'no additional info available',
        },
    },
    {
        Key: 'test/foo/bar/testi_10.bin',
        Size: 384,
        Metadata: { description: 'no description available', additional_info: '' },
    },
    {
        Key: 'test/foo/bar/testi_11.bin',
        Size: 384,
        Metadata: {
            description: 'www www www www www www www www',
            additional_info: 'no additional info available',
        },
    },
    {
        Key: 'test/foo/bar/testi_12.bin',
        Size: 384,
        Metadata: { description: 'just testing', additional_info: '' },
    },
    {
        Key: 'test/foo/bar/testi_13.bin',
        Size: 384,
        Metadata: { description: 'just testing', additional_info: 'no additional info available' },
    },
    {
        Key: 'test/foo/bar/testi_14.bin',
        Size: 384,
        Metadata: {
            description: 'zxcvb asdfg qwert',
            additional_info: 'no additional info available',
        },
    },
    {
        Key: 'test/foo/bar/testi_15.bin',
        Size: 384,
        Metadata: {
            description: 'www www www www www www www www',
            additional_info: 'no additional info available',
        },
    },
];

export const usersList = {
    Users: [
        {
            Username: 'jussi',
            Attributes: [
                { Name: 'sub', Value: '2dbcaf43-518d-4fc4-be92-0cb0b903a39c' },
                { Name: 'email_verified', Value: 'true' },
                { Name: 'phone_number_verified', Value: 'true' },
                { Name: 'phone_number', Value: '+358401234567' },
                { Name: 'email', Value: 'jussi.utunen@mekiwi.org' },
                { Name: 'custom:company', Value: 'ACME' },
            ],
            UserCreateDate: '2021-03-17T18:47:58.037000+00:00',
            UserLastModifiedDate: '2021-03-17T18:47:58.037000+00:00',
            Enabled: true,
            UserStatus: 'FORCE_CHANGE_PASSWORD',
        },
        {
            Username: 'testuser',
            Attributes: [
                { Name: 'sub', Value: 'c7ccea3e-8974-4cd7-bd03-d39d9b15edbe' },
                { Name: 'email_verified', Value: 'true' },
                { Name: 'phone_number_verified', Value: 'true' },
                { Name: 'phone_number', Value: '+358401234567' },
                { Name: 'email', Value: 'non-existent@test.org' },
                { Name: 'custom:company', Value: 'test company name' },
            ],
            UserCreateDate: '2021-03-05T10:35:29.684000+00:00',
            UserLastModifiedDate: '2021-03-05T10:52:07.529000+00:00',
            Enabled: true,
            UserStatus: 'CONFIRMED',
        },
    ],
};
